import { z } from "zod";

/**
 * Login Form Validation Schema
 * ------------------------------------------------------------
 * Validates the login form fields using Zod
 * Fields:
 * - email: required, must be a valid email format
 * - password: required, minimum 6 characters
 * - rememberMe: optional boolean, defaults to false
 */
export const loginSchema = z.object({
  email: z
    .string()
    .min(1, { message: "Email is required" })
    .email({ message: "Please enter a valid email address" }),

  password: z
    .string()
    .min(6, { message: "Password must be at least 6 characters long." })
    .max(50, { message: "Password must not exceed 50 characters." })
    .refine((val) => !/\s/.test(val), {
      message: "Password must not contain spaces.",
    })
    .refine((val) => /[a-z]/.test(val), {
      message: "Password must contain at least one lowercase letter.",
    })
    .refine((val) => /[A-Z]/.test(val), {
      message: "Password must contain at least one uppercase letter.",
    })
    .refine((val) => /\d/.test(val), {
      message: "Password must contain at least one number.",
    }),
    // .refine((val) => /^[A-Za-z\d@#$%!&*]+$/.test(val), {
    //   message: "Password contains invalid characters.",
    // }),

  rememberMe: z.boolean().default(false),
});
